import { Navigate } from 'react-router-dom';

const ProtectedRoutes = ({ children }) => {
  // Retrieve and parse the cookie value
  const tokenName = process.env.REACT_APP_PUBLIC_TOKENNAME
  const token = sessionStorage.getItem(tokenName || "moilToken");
  // Redirect to login if token is not available
  if (!token) {
    return <Navigate to="/login" />;
  }

  return <div>{children}</div>;
};

export default ProtectedRoutes;
